export default __webpack_public_path__ + "static/media/java.3c5854fc.svg";